import React, { Component } from 'react'
import { bindActionCreators} from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import _ from 'lodash'
import update from 'immutability-helper'
import {Breadcrumb, Segment, Dropdown, Button, Label, Icon, Input} from 'semantic-ui-react'
import InventorySearch from '../utils/searches/InventorySearch'
import Dls from '../../lib'
import {api} from '../../api'
import StockTable from './components/stock'
import MovementTable from './components/movement'
import CommissionTable from './components/commissions'
import MovingAverageCost from './components/moving_average_cost'
import ShipSumChart from "./components/shipSumChart"

const types = [
    {key:'inventory',value:'inventory',text:'Inventory Report'},
    {key:'average-cost',value:'average-cost',text:'Inventory Cost Valuation'},
    {key:'movement',value:'movement',text:'History Movement Report by SKU'},
    {key:'commission',value:'commission',text:'Sales Commissions'},
    {key:'ship-sum',value:'ship-sum',text:'Shipped Order By Location'}
];

class ReportPage extends Component {
    constructor() {
        super();
        this.state = {
            report_value: 'inventory',
            warehouse: "0",
            inventories: [

            ],
            loading: false,
            report_component: {
                name: null,
                data: []
            },
            user_id: "",
            from: "",
            to: ""
        }
    }
    //access router
    //this.props.history.push('/dashboard')
    onTypeValueChange = (e, {value}) => {
        this.setState({
            report_value: value
        });
    }
    onWarehouseChange = (e, {value}) => {
        this.setState({
            warehouse: value
        });
    }
    onInventorySelected = (i) => {
        const {id} = i;
        const hasInventory = this.state.inventories.filter(item => {
            return parseInt(item.id) === parseInt(id);
        });
        if (hasInventory.length > 0) {
            return null;
        } else {
            this.setState({
                inventories: update(this.state.inventories, {
                    $push: [i]
                })
            });
        }
    }
    getExceptIds = () => {
        const except = [];
        _.each(this.state.inventories, item => {
            if(_.isObject(item)) {
                except.push(item.id);
            }
        });
        return except;
    }
    removeInventory = (i, index) => {
        this.setState({
            inventories: update(this.state.inventories, {
                $splice: [[index, 1]]
            })
        })
    }
    runReport = () => {
        const ids = {};
        if (this.state.report_value === 'movement' || this.state.report_value === 'average-cost') {
            _.each(this.state.inventories, i => {
                ids[i.id] = i.id;
            });
            if (_.isEmpty(ids)) {
                Dls.info("Please select at least one product");
                return null;
            }
        }
        this.setState({
            loading: true,
            report_component: {
                name: null,
                data: []
            }
        });
        api.report(this.props.jwt, {
            type: this.state.report_value,
            warehouse_id: this.state.warehouse,
            inventoryIds: ids,
            user_id: this.state.user_id,
            from: this.state.from,
            to: this.state.to
        }).then(res => {
            this.setState({
                loading: false,
                report_component: {
                    name: this.state.report_value,
                    data: res.data.data
                }
            });
        }).catch(err => {
            Dls.apiErrorAlert(err);
            this.setState({
                loading: false
            });
        })
    }
    render() {
        const {name, data} = this.state.report_component;
        const warehouses = [{
            key: "0",
            value: "0",
            text: "All Warehouses"
        }];
        _.each(this.props.warehouses, i => {
            warehouses.push(i)
        })
        return (
                <div>
                    <div className="row" style={{ marginBottom: "5px" }}>
                        <div className="col-md-8">
                            <Breadcrumb size="huge">
                                <Breadcrumb.Section>
                                    Reports
                                </Breadcrumb.Section>
                            </Breadcrumb>
                        </div>
                    </div>
                    <div className="row" style={{ marginBottom: "5px" }}>
                        <div className="col-md-12">
                            <Segment>
                                <div className="row">
                                    <div className="col-md-4">
                                        <label style={{
                                                display: 'block',
                                                margin: '0 0 .28571429rem 0',
                                                color: 'rgba(0,0,0,.87)',
                                                fontSize: '.92857143em',
                                                fontWeight: 700,
                                                textTransform: 'none'
                                            }}>Select A Report</label>
                                        <Dropdown 
                                            value={this.state.report_value}
                                            onChange={(e, data) => this.onTypeValueChange(e, data)}
                                            fluid selection options={types} />
                                    </div>
                                    {this.state.report_value === 'inventory' ? <div className="col-md-4">
                                        <label style={{
                                                display: 'block',
                                                margin: '0 0 .28571429rem 0',
                                                color: 'rgba(0,0,0,.87)',
                                                fontSize: '.92857143em',
                                                fontWeight: 700,
                                                textTransform: 'none'
                                            }}>Warehouse</label>
                                        <Dropdown 
                                            value={this.state.warehouse}
                                            onChange={(e, data) => this.onWarehouseChange(e, data)}
                                            fluid selection options={warehouses} />
                                    </div> : null}
                                </div>
                                {this.state.report_value === 'movement' || this.state.report_value === 'average-cost' ? <div className="row">
                                    <div className="col-md-12" style={{marginTop: '10px'}}>
                                        <InventorySearch 
                                            jwt={this.props.jwt}
                                            onSelected={(i) => {this.onInventorySelected(i)}}
                                            exceptIds={this.getExceptIds()}
                                            requireInventoryPricing={false}
                                            relationId="0"
                                        />
                                    </div>
                                    <div className="col-md-12" style={{marginTop: '3px', paddingLeft:'5px', paddingRight:'5px'}}>
                                        {this.state.inventories.map((i,index) => {
                                            return <Label key={i.id} size='tiny' color='orange' onClick={() => {this.removeInventory(i,index)}}>
                                                {i.sku}
                                                <Icon name='delete' />
                                            </Label>
                                        })}
                                    </div>
                                </div> : null}
                                {this.state.report_value === 'commission' ? <div className="row">
                                    <div className="col-md-4">
                                        <label style={{
                                                display: 'block',
                                                margin: '0 0 .28571429rem 0',
                                                color: 'rgba(0,0,0,.87)',
                                                fontSize: '.92857143em',
                                                fontWeight: 700,
                                                textTransform: 'none'
                                            }}>User</label>
                                        <Dropdown 
                                            value={this.state.user_id}
                                            onChange={(e, {value}) => this.setState({user_id: value})}
                                            fluid selection options={this.props.users} />
                                    </div>
                                    <div className="col-md-4">
                                        <label style={{
                                                display: 'block',
                                                margin: '0 0 .28571429rem 0',
                                                color: 'rgba(0,0,0,.87)',
                                                fontSize: '.92857143em',
                                                fontWeight: 700,
                                                textTransform: 'none'
                                            }}>From Date (YYYY-MM-DD)</label>
                                        <Input 
                                            type='date'
                                            fluid
                                            value={this.state.from}
                                            onChange={(e) => {
                                                this.setState({
                                                    from: e.target.value
                                                })
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label style={{
                                                display: 'block',
                                                margin: '0 0 .28571429rem 0',
                                                color: 'rgba(0,0,0,.87)',
                                                fontSize: '.92857143em',
                                                fontWeight: 700,
                                                textTransform: 'none'
                                            }}>To Date (YYYY-MM-DD)</label>
                                        <Input 
                                            type='date'
                                            fluid
                                            value={this.state.to}
                                            onChange={(e) => {
                                                this.setState({
                                                    to: e.target.value
                                                })
                                            }}
                                        />
                                    </div>
                                </div> : null}
                                <div className="col-md-12" style={{marginTop: '10px'}}>
                                    <Button size='mini' color='teal'
                                        onClick={() => {this.runReport()}}
                                        disabled={this.state.loading}>Run</Button>
                                </div>
                            </Segment>
                        </div>
                    </div>
                
                    {name === 'inventory' ? <StockTable data={data} /> : null}
                    {name === 'commission' ? <CommissionTable data={data} /> : null}
                    {name === 'movement' ? <MovementTable data={data} warehouses={this.props.warehouses} /> : null}
                    {name === 'average-cost' ? <MovingAverageCost data={data} /> : null}
                    {name === 'ship-sum' ? <ShipSumChart data={_.isEmpty(data) ? {
                        axis:[],
                        lines:[]
                    } : data} /> : null}
                </div>
                
        )
    }
}

ReportPage.propTypes = {
    //history: PropTypes.shape({
    //    push: PropTypes.func.isRequired
    //}).isRequired,
    jwt: PropTypes.string.isRequired,
    warehouses: PropTypes.array.isRequired
};

function mapStateToProps(state) {
    return {
        jwt: state.auth.jwt,
        warehouses: state.system.resources.warehouses,
        users: state.system.resources.users
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportPage)


// WEBPACK FOOTER //
// ./src/components/reports/report.js